<template>
  <v-app id="pho">
    <router-view />
  </v-app>
</template>
<script>
import {useContext} from '@/compat';
import {computed, onBeforeMount, provide,} from 'vue';
import useServerTime from '@/helpers/misc/date/useServerTime';
import {DefaultApolloClient} from "@vue/apollo-composable";
import {createGraphqlClient} from "@/api/graphql";

const defaultLayout = 'default';

export default {
  setup(props, context) {
    const {$i18n, $route} = useContext();
    const {setup: setupServerTime} = useServerTime();

    provide(DefaultApolloClient, createGraphqlClient());

    const layout = computed(() => (`${$route.meta.layout || defaultLayout}-layout`));
    provide('sample', 'sample-text');

    onBeforeMount(() => {
      setupServerTime();
      document.getElementsByTagName('html')[0].setAttribute('lang', $i18n.locale);
    });

    return {
      layout,
    };
  },
};
</script>
<style>
.pho-fragment {
  display: contents;
}

#pho {
  background-image: url('./assets/bg-pattern.png');
}
</style>
